import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-stripe-success',
  standalone: true,
  template: `
    <div style="padding:16px">
      Finalizando pagamento...
    </div>
  `,
})
export class StripeSuccessComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const storeId = this.route.snapshot.queryParamMap.get('store_id') || '';

    // ✅ envia sinal para a aba principal
    try {
      window.opener?.postMessage(
        {
          type: 'STRIPE_CHECKOUT_DONE',
          result: 'success',
          store_id: storeId
        },
        'https://app.slicksell.com.br'
      );
    } catch {}

    // ✅ tenta fechar popup
    try {
      window.close();
    } catch {}
  }
}
